import { serviceGroupActionTypes } from './serviceGroup.types';
import http from '../../services/http';
import { logOut } from '../user/user.actions';
import { setLoading, setNotLoading } from '../loading/loading.actions';

const setServiceGroups = serviceGroups => {
    return {
        type: serviceGroupActionTypes.SET_SERVICE_GROUPS,
        payload: serviceGroups
    }
};

const setServiceGroup = serviceGroup => {
    return {
        type: serviceGroupActionTypes.SET_SERVICE_GROUP,
        payload: serviceGroup
    }
};

export const getServiceGroups = () => {
    return async dispatch => {
        dispatch(setLoading());
        try {
            const response = await http.get(`/groups`);
            dispatch(setServiceGroups(response.data));
        } catch (error) {
            dispatch(handleError(error));
        } finally {
            dispatch(setNotLoading());
        }
    };
};

export const getServiceGroup = serviceGroupId => {
    return async dispatch => {
        try {
            const response = await http.get(`/groups/${serviceGroupId}`);
            dispatch(setServiceGroup(response.data));
        } catch (error) {
            dispatch(handleError(error));
        }
    };
};

export const createServiceGroup = data => {
    return async dispatch => {
        try {
            const response = await http.post(`/groups`, data);
            dispatch(setServiceGroup(response.data));
            dispatch(getServiceGroups());
        } catch (error) {
            dispatch(handleError(error));
        }
    };
};

export const updateServiceGroup = data => {
    return async dispatch => {
        try {
            const id = data.id ?? data.serviceGroup_id;
            const response = await http.put(`/groups/${id}`, data);
            dispatch(setServiceGroup(response.data));
            dispatch(getServiceGroups());
        } catch (error) {
            dispatch(handleError(error));
        }
    };
};

export const deleteServiceGroup = serviceGroupId => {
    return async dispatch => {
        try {
            await http.delete(`/groups/${serviceGroupId}`);
            dispatch(getServiceGroups());
        } catch (error) {
            dispatch(handleError(error));
        }
    };
};

export const setTextConfigs = textConfigs => {
    return {
        type: serviceGroupActionTypes.SET_TEXT_CONFIGS,
        payload: textConfigs
    }
};

export const setTimeConfigs = timeConfigs => {
    return {
        type: serviceGroupActionTypes.SET_TIME_CONFIGS,
        payload: timeConfigs
    }
};

export const getTextConfigs = () => {
    return async dispatch => {
        try {
            const response = await http.get(`/text_configs`);
            dispatch(setTextConfigs(response.data));
        } catch (error) {
            dispatch(handleError(error));
        }
    };
};

export const getTimeConfigs = () => {
    return async dispatch => {
        try {
            const response = await http.get(`/time_configs`);
            dispatch(setTimeConfigs(response.data));
        } catch (error) {
            dispatch(handleError(error));
        }
    };
};

export const getTextConfig = (text_configs_id) => {
    return async dispatch => {
        try {
            const response = await http.get(`/text_configs/${text_configs_id}`);
            dispatch(setTextConfigs(response.data));
        } catch (error) {
            dispatch(handleError(error));
        }
    };
};

export const getTimeConfig = (time_configs_id) => {
    return async dispatch => {
        try {
            const response = await http.get(`/time_configs/${time_configs_id}`);
            dispatch(setTimeConfigs(response.data));
        } catch (error) {
            dispatch(handleError(error));
        }
    };
};

export const updateTextConfig = (data) => {
    return async dispatch => {
        dispatch(setLoading());
        try {
            const response = await http.put(`/text_configs/${data.service_group_id}`, data);
            dispatch(setTextConfigs(response.data));
        } catch (error) {
            dispatch(handleError(error));
        } finally {
            dispatch(setNotLoading());
        }
    };
};

export const updateTimeConfig = (data) => {
    return async dispatch => {
        dispatch(setLoading());
        try {
            const response = await http.put(`/time_configs/${data.service_group_id}`, data);
            dispatch(setTimeConfigs(response.data));
        } catch (error) {
            dispatch(handleError(error));
        } finally {
            dispatch(setNotLoading());
        }
    };
};

export const setOpenHours = openHours => {
    return {
        type: serviceGroupActionTypes.SET_OPEN_HOURS,
        payload: openHours
    }
};

// Busca os horários de serviço (open_hours) do departamento (service_group) informado.
export const getOpenHours = (serviceGroupId) => {
    return async dispatch => {
        try {
            const response = await http.get(`/groups/${serviceGroupId}/open-hours`);
            dispatch(setOpenHours(response.data.open_hours || []));
        } catch (error) {
            dispatch(handleError(error));
        }
    };
};

// Cria/atualiza os horários de serviço do departamento. hours = [{ day_of_week, opening_time, closing_time }].
export const updateOpenHours = (serviceGroupId, hours) => {
    return async dispatch => {
        dispatch(setLoading());
        try {
            const response = await http.put(`/groups/${serviceGroupId}/open-hours`, { hours });
            dispatch(setOpenHours(response.data.open_hours || []));
        } catch (error) {
            dispatch(handleError(error));
        } finally {
            dispatch(setNotLoading());
        }
    };
};

const handleError = error => {
    return dispatch => {
        if (error.response && (error.response.status === 401 || error.response.data.error === 'Token Error')) {
            dispatch(logOut());
        } else {
            console.log(error);
        }
    }
};